import { render, staticRenderFns } from "./NameLang.vue?vue&type=template&id=6892eca4"
import script from "./NameLang.vue?vue&type=script&lang=js"
export * from "./NameLang.vue?vue&type=script&lang=js"
import style0 from "./NameLang.less?vue&type=style&index=0&prod&lang=less&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports